<template>
  <!-- App -->
  <f7-app :params="f7params">

    <!-- Statusbar -->
    <f7-statusbar></f7-statusbar>

    <!-- Left Panel -->
    <f7-panel left cover :color-theme="themeColor">
      <f7-view url="/panel-left"></f7-view>
    </f7-panel>

    <!-- Right Panel -->
    <f7-panel right cover :color-theme="themeColor" style="width: 80%; max-width: 360px;">
      <f7-view url="/panel-right" name="right"></f7-view>
    </f7-panel>

    <!-- :color-theme="store ? store.themeColor : null" -->
    <!-- Main View -->
    <f7-view
      id="main-view"
      url="/"
      main
      :color-theme="themeColor"
      :stackPages="true"
      :pushState="true"
      :pushStateSeparator="pushStateSeparator"
      :pushStateRoot="pushStateRoot">
    </f7-view>

    <f7-routable-modals />
  </f7-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import routes from './routes'
import bowser from 'bowser'
import { storeClient } from '@/service/apiClients'

export default {
  name: 'app',
  dependencies: [
    'baseUrl',
    'platformUtils',
    'themeColor'
  ],
  data () {
    return {
      pushStateSeparator: this.platformUtils.isWeb(process.env.VUE_APP_PLATFORM) ? '' : '#!',
      pushStateRoot: this.platformUtils.isWeb(process.env.VUE_APP_PLATFORM) ? this.baseUrl : document.location.pathname,
      f7params: {
        id: 'tw.ezmeals.order',
        name: 'EZMeals',
        theme: process.env.VUE_APP_THEME,
        routes,
        panel: {
          leftBreakpoint: 768
          // rightBreakpoint: 768
        }
      }
    }
  },
  computed: {
    // ...mapState(['store']),
    ...mapState('orderModule', ['orderList']),
    ...mapGetters(['storeId'])
  },
  watch: {
    // store (v) {
    //   document.querySelector('meta[name="theme-color"]').setAttribute('content', v.themeColor)
    // }
  },
  mounted () {
    this.$nextTick(async () => {
      const { data: result } = await storeClient.get('/versions/order')
      if (!this.isValidVersion(result.version)) {
        this.$f7.dialog.alert(`您的應用程式版本為 ${process.env.VUE_APP_VERSION} 請更新至最新版: ${result.version}`, '有新版本的應用程式', () => {
          location.reload()
        })
      }

      // Replaced node-only `useragent` with `bowser` (already a dep, browser-safe).
      // bowser 1.x exposes the parsed UA as a flat object.
      const ua = bowser._detect ? bowser._detect(navigator.userAgent) : bowser
      if (ua && ua.chrome && ua.mobile && parseInt(ua.version, 10) < 51) {
        this.$f7.dialog.alert('您的瀏覽器版本為 Chrome ' + ua.version + '，為了有最好的使用者體驗，建議您將瀏覽器更新至最新版', '小提示')
      }
    })
  },
  methods: {
    isPanelAlwaysShows () {
      return this.$f7.params.panel.rightBreakpoint > document.body.clientWidth
    },
    isValidVersion (v) {
      try {
        const latest = v.split('.')
        const current = process.env.VUE_APP_VERSION.split('.')
        return current[0] === latest[0] && current[1] === latest[1] && current[2] === latest[2]
      } catch (e) {
        console.error(e.message)
        return false
      }
    }
  }
}
</script>

<style lang="scss">
@import url(//fonts.googleapis.com/earlyaccess/notosanstc.css);

#app {
  font-family: 'Noto Sans TC', sans-serif;
}

/* Left Panel right border when it is visible by breakpoint */
.panel-left.panel-visible-by-breakpoint:before {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 1px;
  background: rgba(0,0,0,0.1);
  content: '';
  z-index: 6000;
}

/* Right Panel right border when it is visible by breakpoint */
.panel-right.panel-visible-by-breakpoint:before {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 1px;
  background: rgba(0,0,0,0.1);
  content: '';
  z-index: 6000;
}

/* Hide navbar link which opens left panel when it is visible by breakpoint */
.panel-left.panel-visible-by-breakpoint ~ .view .navbar .panel-open[data-panel="left"] {
  display: none;
}

/*
  Extra borders for main view and left panel for iOS theme when it behaves as panel (before breakpoint size)
*/
.ios .panel-left:not(.panel-visible-by-breakpoint).panel-active ~ .view-main:before,
.ios .panel-left:not(.panel-visible-by-breakpoint).panel-closing ~ .view-main:before {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 1px;
  background: rgba(0,0,0,0.1);
  content: '';
  z-index: 6000;
}
</style>
